import { xEnsureFloat64 } from '../x';
export function xyEnsureFloat64(data) {
    return {
        x: xEnsureFloat64(data.x),
        y: xEnsureFloat64(data.y),
    };
}
//# sourceMappingURL=xyEnsureFloat64.js.map